var _Defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Defs } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: font */

function SvgSlick(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null)));
}

export default SvgSlick;